import { jsx as wr } from "react/jsx-runtime";
import { c as Ds } from "react/compiler-runtime";
import re, { createContext as Ys } from "react";
import { enableES5 as Os } from "immer";
import bs from "react-markdown";
import Ts from "remark-gfm";
import xs from "rehype-raw";
import { renderToString as Ps } from "react-dom/server";
import { useSpeechToText as Ns } from "../utilities/sound/speechToText.js";
import { useTextToSpeak as Ws } from "../utilities/sound/textToSpeech.js";
var xr = /* @__PURE__ */ (function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, n) {
      s.__proto__ = n;
    } || function(s, n) {
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (s[a] = n[a]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function s() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (s.prototype = r.prototype, new s());
  };
})(), Rs = function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, s, n, a, i;
  return i = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(u) {
    return function(f) {
      return h([u, f]);
    };
  }
  function h(u) {
    if (s) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (s = 1, n && (a = u[0] & 2 ? n.return : u[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, u[1])).done) return a;
      switch (n = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, n = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = u;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(u);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (f) {
      u = [6, f], n = 0;
    } finally {
      s = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, mt = function(e, t) {
  for (var r = 0, s = t.length, n = e.length; r < s; r++, n++)
    e[n] = t[r];
  return e;
}, Fs = Object.defineProperty, Cs = Object.defineProperties, Is = Object.getOwnPropertyDescriptors, pr = Object.getOwnPropertySymbols, Es = Object.prototype.hasOwnProperty, As = Object.prototype.propertyIsEnumerable, vr = function(e, t, r) {
  return t in e ? Fs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
}, Ve = function(e, t) {
  for (var r in t || (t = {}))
    Es.call(t, r) && vr(e, r, t[r]);
  if (pr)
    for (var s = 0, n = pr(t); s < n.length; s++) {
      var r = n[s];
      As.call(t, r) && vr(e, r, t[r]);
    }
  return e;
}, Ft = function(e, t) {
  return Cs(e, Is(t));
}, Ls = function(e, t, r) {
  return new Promise(function(s, n) {
    var a = function(h) {
      try {
        o(r.next(h));
      } catch (u) {
        n(u);
      }
    }, i = function(h) {
      try {
        o(r.throw(h));
      } catch (u) {
        n(u);
      }
    }, o = function(h) {
      return h.done ? s(h.value) : Promise.resolve(h.value).then(a, i);
    };
    o((r = r.apply(e, t)).next());
  });
};
function Ne(e, t) {
  function r() {
    for (var s = [], n = 0; n < arguments.length; n++)
      s[n] = arguments[n];
    if (t) {
      var a = t.apply(void 0, s);
      if (!a)
        throw new Error("prepareAction did not return an object");
      return Ve(Ve({
        type: e,
        payload: a.payload
      }, "meta" in a && { meta: a.meta }), "error" in a && { error: a.error });
    }
    return { type: e, payload: s[0] };
  }
  return r.toString = function() {
    return "" + e;
  }, r.type = e, r.match = function(s) {
    return s.type === e;
  }, r;
}
(function(e) {
  xr(t, e);
  function t() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    var n = e.apply(this, r) || this;
    return Object.setPrototypeOf(n, t.prototype), n;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return e.prototype.concat.apply(this, r);
  }, t.prototype.prepend = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, mt([void 0], r[0].concat(this))))() : new (t.bind.apply(t, mt([void 0], r.concat(this))))();
  }, t;
})(Array);
(function(e) {
  xr(t, e);
  function t() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    var n = e.apply(this, r) || this;
    return Object.setPrototypeOf(n, t.prototype), n;
  }
  return Object.defineProperty(t, Symbol.species, {
    get: function() {
      return t;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.concat = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return e.prototype.concat.apply(this, r);
  }, t.prototype.prepend = function() {
    for (var r = [], s = 0; s < arguments.length; s++)
      r[s] = arguments[s];
    return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, mt([void 0], r[0].concat(this))))() : new (t.bind.apply(t, mt([void 0], r.concat(this))))();
  }, t;
})(Array);
process.env.NODE_ENV;
process.env.NODE_ENV;
var Us = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Ut = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", r = e; r--; )
    t += Us[Math.random() * 64 | 0];
  return t;
}, Hs = [
  "name",
  "message",
  "stack",
  "code"
], Ct = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), kr = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  })()
), Vs = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, r = 0, s = Hs; r < s.length; r++) {
      var n = s[r];
      typeof e[n] == "string" && (t[n] = e[n]);
    }
    return t;
  }
  return { message: String(e) };
};
(function() {
  function e(t, r, s) {
    var n = Ne(t + "/fulfilled", function(f, D, v, E) {
      return {
        payload: f,
        meta: Ft(Ve({}, E || {}), {
          arg: v,
          requestId: D,
          requestStatus: "fulfilled"
        })
      };
    }), a = Ne(t + "/pending", function(f, D, v) {
      return {
        payload: void 0,
        meta: Ft(Ve({}, v || {}), {
          arg: D,
          requestId: f,
          requestStatus: "pending"
        })
      };
    }), i = Ne(t + "/rejected", function(f, D, v, E, R) {
      return {
        payload: E,
        error: (s && s.serializeError || Vs)(f || "Rejected"),
        meta: Ft(Ve({}, R || {}), {
          arg: v,
          requestId: D,
          rejectedWithValue: !!E,
          requestStatus: "rejected",
          aborted: f?.name === "AbortError",
          condition: f?.name === "ConditionError"
        })
      };
    }), o = !1, h = typeof AbortController < "u" ? AbortController : (
      /** @class */
      (function() {
        function f() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return f.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (o || (o = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, f;
      })()
    );
    function u(f) {
      return function(D, v, E) {
        var R = s?.idGenerator ? s.idGenerator(f) : Ut(), _e = new h(), De;
        function Ke(ge) {
          De = ge, _e.abort();
        }
        var Ye = (function() {
          return Ls(this, null, function() {
            var ge, Oe, x, A, we, ee, pe;
            return Rs(this, function(j) {
              switch (j.label) {
                case 0:
                  return j.trys.push([0, 4, , 5]), A = (ge = s?.condition) == null ? void 0 : ge.call(s, f, { getState: v, extra: E }), Gs(A) ? [4, A] : [3, 2];
                case 1:
                  A = j.sent(), j.label = 2;
                case 2:
                  if (A === !1 || _e.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return we = new Promise(function(P, te) {
                    return _e.signal.addEventListener("abort", function() {
                      return te({
                        name: "AbortError",
                        message: De || "Aborted"
                      });
                    });
                  }), D(a(R, f, (Oe = s?.getPendingMeta) == null ? void 0 : Oe.call(s, { requestId: R, arg: f }, { getState: v, extra: E }))), [4, Promise.race([
                    we,
                    Promise.resolve(r(f, {
                      dispatch: D,
                      getState: v,
                      extra: E,
                      requestId: R,
                      signal: _e.signal,
                      abort: Ke,
                      rejectWithValue: function(P, te) {
                        return new Ct(P, te);
                      },
                      fulfillWithValue: function(P, te) {
                        return new kr(P, te);
                      }
                    })).then(function(P) {
                      if (P instanceof Ct)
                        throw P;
                      return P instanceof kr ? n(P.payload, R, f, P.meta) : n(P, R, f);
                    })
                  ])];
                case 3:
                  return x = j.sent(), [3, 5];
                case 4:
                  return ee = j.sent(), x = ee instanceof Ct ? i(null, R, f, ee.payload, ee.meta) : i(ee, R, f), [3, 5];
                case 5:
                  return pe = s && !s.dispatchConditionRejection && i.match(x) && x.meta.condition, pe || D(x), [2, x];
              }
            });
          });
        })();
        return Object.assign(Ye, {
          abort: Ke,
          requestId: R,
          arg: f,
          unwrap: function() {
            return Ye.then(js);
          }
        });
      };
    }
    return Object.assign(u, {
      pending: a,
      rejected: i,
      fulfilled: n,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
})();
function js(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Gs(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var qt = "listenerMiddleware";
Ne(qt + "/add");
Ne(qt + "/removeAll");
Ne(qt + "/remove");
var Sr;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
Os();
var Pr;
function d() {
  return Pr.apply(null, arguments);
}
function zs(e) {
  Pr = e;
}
function Z(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Se(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function w(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Bt(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (w(e, t))
      return !1;
  return !0;
}
function C(e) {
  return e === void 0;
}
function ue(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function qe(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Nr(e, t) {
  var r = [], s, n = e.length;
  for (s = 0; s < n; ++s)
    r.push(t(e[s], s));
  return r;
}
function he(e, t) {
  for (var r in t)
    w(t, r) && (e[r] = t[r]);
  return w(t, "toString") && (e.toString = t.toString), w(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function K(e, t, r, s) {
  return es(e, t, r, s, !0).utc();
}
function Zs() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function y(e) {
  return e._pf == null && (e._pf = Zs()), e._pf;
}
var Ht;
Array.prototype.some ? Ht = Array.prototype.some : Ht = function(e) {
  var t = Object(this), r = t.length >>> 0, s;
  for (s = 0; s < r; s++)
    if (s in t && e.call(this, t[s], s, t))
      return !0;
  return !1;
};
function Jt(e) {
  var t = null, r = !1, s = e._d && !isNaN(e._d.getTime());
  if (s && (t = y(e), r = Ht.call(t.parsedDateParts, function(n) {
    return n != null;
  }), s = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (s = s && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = s;
  else
    return s;
  return e._isValid;
}
function vt(e) {
  var t = K(NaN);
  return e != null ? he(y(t), e) : y(t).userInvalidated = !0, t;
}
var Mr = d.momentProperties = [], It = !1;
function Qt(e, t) {
  var r, s, n, a = Mr.length;
  if (C(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), C(t._i) || (e._i = t._i), C(t._f) || (e._f = t._f), C(t._l) || (e._l = t._l), C(t._strict) || (e._strict = t._strict), C(t._tzm) || (e._tzm = t._tzm), C(t._isUTC) || (e._isUTC = t._isUTC), C(t._offset) || (e._offset = t._offset), C(t._pf) || (e._pf = y(t)), C(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      s = Mr[r], n = t[s], C(n) || (e[s] = n);
  return e;
}
function Be(e) {
  Qt(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), It === !1 && (It = !0, d.updateOffset(this), It = !1);
}
function $(e) {
  return e instanceof Be || e != null && e._isAMomentObject != null;
}
function Wr(e) {
  d.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function H(e, t) {
  var r = !0;
  return he(function() {
    if (d.deprecationHandler != null && d.deprecationHandler(null, e), r) {
      var s = [], n, a, i, o = arguments.length;
      for (a = 0; a < o; a++) {
        if (n = "", typeof arguments[a] == "object") {
          n += `
[` + a + "] ";
          for (i in arguments[0])
            w(arguments[0], i) && (n += i + ": " + arguments[0][i] + ", ");
          n = n.slice(0, -2);
        } else
          n = arguments[a];
        s.push(n);
      }
      Wr(
        e + `
Arguments: ` + Array.prototype.slice.call(s).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Dr = {};
function Rr(e, t) {
  d.deprecationHandler != null && d.deprecationHandler(e, t), Dr[e] || (Wr(t), Dr[e] = !0);
}
d.suppressDeprecationWarnings = !1;
d.deprecationHandler = null;
function X(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function $s(e) {
  var t, r;
  for (r in e)
    w(e, r) && (t = e[r], X(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Vt(e, t) {
  var r = he({}, e), s;
  for (s in t)
    w(t, s) && (Se(e[s]) && Se(t[s]) ? (r[s] = {}, he(r[s], e[s]), he(r[s], t[s])) : t[s] != null ? r[s] = t[s] : delete r[s]);
  for (s in e)
    w(e, s) && !w(t, s) && Se(e[s]) && (r[s] = he({}, r[s]));
  return r;
}
function Kt(e) {
  e != null && this.set(e);
}
var jt;
Object.keys ? jt = Object.keys : jt = function(e) {
  var t, r = [];
  for (t in e)
    w(e, t) && r.push(t);
  return r;
};
var qs = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Bs(e, t, r) {
  var s = this._calendar[e] || this._calendar.sameElse;
  return X(s) ? s.call(t, r) : s;
}
function Q(e, t, r) {
  var s = "" + Math.abs(e), n = t - s.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + s;
}
var Xt = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, ut = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Et = {}, We = {};
function m(e, t, r, s) {
  var n = s;
  typeof s == "string" && (n = function() {
    return this[s]();
  }), e && (We[e] = n), t && (We[t[0]] = function() {
    return Q(n.apply(this, arguments), t[1], t[2]);
  }), r && (We[r] = function() {
    return this.localeData().ordinal(
      n.apply(this, arguments),
      e
    );
  });
}
function Js(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function Qs(e) {
  var t = e.match(Xt), r, s;
  for (r = 0, s = t.length; r < s; r++)
    We[t[r]] ? t[r] = We[t[r]] : t[r] = Js(t[r]);
  return function(n) {
    var a = "", i;
    for (i = 0; i < s; i++)
      a += X(t[i]) ? t[i].call(n, e) : t[i];
    return a;
  };
}
function ft(e, t) {
  return e.isValid() ? (t = Fr(t, e.localeData()), Et[t] = Et[t] || Qs(t), Et[t](e)) : e.localeData().invalidDate();
}
function Fr(e, t) {
  var r = 5;
  function s(n) {
    return t.longDateFormat(n) || n;
  }
  for (ut.lastIndex = 0; r >= 0 && ut.test(e); )
    e = e.replace(
      ut,
      s
    ), ut.lastIndex = 0, r -= 1;
  return e;
}
var Ks = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Xs(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(Xt).map(function(s) {
    return s === "MMMM" || s === "MM" || s === "DD" || s === "dddd" ? s.slice(1) : s;
  }).join(""), this._longDateFormat[e]);
}
var en = "Invalid date";
function tn() {
  return this._invalidDate;
}
var rn = "%d", sn = /\d{1,2}/;
function nn(e) {
  return this._ordinal.replace("%d", e);
}
var an = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function on(e, t, r, s) {
  var n = this._relativeTime[r];
  return X(n) ? n(e, t, r, s) : n.replace(/%d/i, e);
}
function ln(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return X(r) ? r(t) : r.replace(/%s/i, t);
}
var Yr = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function V(e) {
  return typeof e == "string" ? Yr[e] || Yr[e.toLowerCase()] : void 0;
}
function er(e) {
  var t = {}, r, s;
  for (s in e)
    w(e, s) && (r = V(s), r && (t[r] = e[s]));
  return t;
}
var un = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function dn(e) {
  var t = [], r;
  for (r in e)
    w(e, r) && t.push({ unit: r, priority: un[r] });
  return t.sort(function(s, n) {
    return s.priority - n.priority;
  }), t;
}
var Cr = /\d/, I = /\d\d/, Ir = /\d{3}/, tr = /\d{4}/, kt = /[+-]?\d{6}/, M = /\d\d?/, Er = /\d\d\d\d?/, Ar = /\d\d\d\d\d\d?/, St = /\d{1,3}/, rr = /\d{1,4}/, Mt = /[+-]?\d{1,6}/, Ce = /\d+/, Dt = /[+-]?\d+/, fn = /Z|[+-]\d\d:?\d\d/gi, Yt = /Z|[+-]\d\d(?::?\d\d)?/gi, cn = /[+-]?\d+(\.\d{1,3})?/, Je = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Ie = /^[1-9]\d?/, sr = /^([1-9]\d|\d)/, yt;
yt = {};
function c(e, t, r) {
  yt[e] = X(t) ? t : function(s, n) {
    return s && r ? r : t;
  };
}
function hn(e, t) {
  return w(yt, e) ? yt[e](t._strict, t._locale) : new RegExp(mn(e));
}
function mn(e) {
  return oe(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, s, n, a) {
        return r || s || n || a;
      }
    )
  );
}
function oe(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function U(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function _(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = U(t)), r;
}
var Gt = {};
function k(e, t) {
  var r, s = t, n;
  for (typeof e == "string" && (e = [e]), ue(t) && (s = function(a, i) {
    i[t] = _(a);
  }), n = e.length, r = 0; r < n; r++)
    Gt[e[r]] = s;
}
function Qe(e, t) {
  k(e, function(r, s, n, a) {
    n._w = n._w || {}, t(r, n._w, n, a);
  });
}
function yn(e, t, r) {
  t != null && w(Gt, e) && Gt[e](t, r._a, r, e);
}
function Ot(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var W = 0, ae = 1, J = 2, b = 3, z = 4, ie = 5, ke = 6, _n = 7, gn = 8;
m("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Q(e, 4) : "+" + e;
});
m(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
m(0, ["YYYY", 4], 0, "year");
m(0, ["YYYYY", 5], 0, "year");
m(0, ["YYYYYY", 6, !0], 0, "year");
c("Y", Dt);
c("YY", M, I);
c("YYYY", rr, tr);
c("YYYYY", Mt, kt);
c("YYYYYY", Mt, kt);
k(["YYYYY", "YYYYYY"], W);
k("YYYY", function(e, t) {
  t[W] = e.length === 2 ? d.parseTwoDigitYear(e) : _(e);
});
k("YY", function(e, t) {
  t[W] = d.parseTwoDigitYear(e);
});
k("Y", function(e, t) {
  t[W] = parseInt(e, 10);
});
function je(e) {
  return Ot(e) ? 366 : 365;
}
d.parseTwoDigitYear = function(e) {
  return _(e) + (_(e) > 68 ? 1900 : 2e3);
};
var Lr = Ee("FullYear", !0);
function wn() {
  return Ot(this.year());
}
function Ee(e, t) {
  return function(r) {
    return r != null ? (Ur(this, e, r), d.updateOffset(this, t), this) : Ge(this, e);
  };
}
function Ge(e, t) {
  if (!e.isValid())
    return NaN;
  var r = e._d, s = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return s ? r.getUTCMilliseconds() : r.getMilliseconds();
    case "Seconds":
      return s ? r.getUTCSeconds() : r.getSeconds();
    case "Minutes":
      return s ? r.getUTCMinutes() : r.getMinutes();
    case "Hours":
      return s ? r.getUTCHours() : r.getHours();
    case "Date":
      return s ? r.getUTCDate() : r.getDate();
    case "Day":
      return s ? r.getUTCDay() : r.getDay();
    case "Month":
      return s ? r.getUTCMonth() : r.getMonth();
    case "FullYear":
      return s ? r.getUTCFullYear() : r.getFullYear();
    default:
      return NaN;
  }
}
function Ur(e, t, r) {
  var s, n, a, i, o;
  if (!(!e.isValid() || isNaN(r))) {
    switch (s = e._d, n = e._isUTC, t) {
      case "Milliseconds":
        return void (n ? s.setUTCMilliseconds(r) : s.setMilliseconds(r));
      case "Seconds":
        return void (n ? s.setUTCSeconds(r) : s.setSeconds(r));
      case "Minutes":
        return void (n ? s.setUTCMinutes(r) : s.setMinutes(r));
      case "Hours":
        return void (n ? s.setUTCHours(r) : s.setHours(r));
      case "Date":
        return void (n ? s.setUTCDate(r) : s.setDate(r));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    a = r, i = e.month(), o = e.date(), o = o === 29 && i === 1 && !Ot(a) ? 28 : o, n ? s.setUTCFullYear(a, i, o) : s.setFullYear(a, i, o);
  }
}
function pn(e) {
  return e = V(e), X(this[e]) ? this[e]() : this;
}
function vn(e, t) {
  if (typeof e == "object") {
    e = er(e);
    var r = dn(e), s, n = r.length;
    for (s = 0; s < n; s++)
      this[r[s].unit](e[r[s].unit]);
  } else if (e = V(e), X(this[e]))
    return this[e](t);
  return this;
}
function kn(e, t) {
  return (e % t + t) % t;
}
var O;
Array.prototype.indexOf ? O = Array.prototype.indexOf : O = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function nr(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = kn(t, 12);
  return e += (t - r) / 12, r === 1 ? Ot(e) ? 29 : 28 : 31 - r % 7 % 2;
}
m("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
m("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
m("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
c("M", M, Ie);
c("MM", M, I);
c("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
c("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
k(["M", "MM"], function(e, t) {
  t[ae] = _(e) - 1;
});
k(["MMM", "MMMM"], function(e, t, r, s) {
  var n = r._locale.monthsParse(e, s, r._strict);
  n != null ? t[ae] = n : y(r).invalidMonth = e;
});
var Sn = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Hr = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Vr = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Mn = Je, Dn = Je;
function Yn(e, t) {
  return e ? Z(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Vr).test(t) ? "format" : "standalone"][e.month()] : Z(this._months) ? this._months : this._months.standalone;
}
function On(e, t) {
  return e ? Z(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Vr.test(t) ? "format" : "standalone"][e.month()] : Z(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function bn(e, t, r) {
  var s, n, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s)
      a = K([2e3, s]), this._shortMonthsParse[s] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[s] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (n = O.call(this._shortMonthsParse, i), n !== -1 ? n : null) : (n = O.call(this._longMonthsParse, i), n !== -1 ? n : null) : t === "MMM" ? (n = O.call(this._shortMonthsParse, i), n !== -1 ? n : (n = O.call(this._longMonthsParse, i), n !== -1 ? n : null)) : (n = O.call(this._longMonthsParse, i), n !== -1 ? n : (n = O.call(this._shortMonthsParse, i), n !== -1 ? n : null));
}
function Tn(e, t, r) {
  var s, n, a;
  if (this._monthsParseExact)
    return bn.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++) {
    if (n = K([2e3, s]), r && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp(
      "^" + this.months(n, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[s] = new RegExp(
      "^" + this.monthsShort(n, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[s] && (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[s] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[s].test(e))
      return s;
    if (r && t === "MMM" && this._shortMonthsParse[s].test(e))
      return s;
    if (!r && this._monthsParse[s].test(e))
      return s;
  }
}
function jr(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = _(t);
    else if (t = e.localeData().monthsParse(t), !ue(t))
      return e;
  }
  var r = t, s = e.date();
  return s = s < 29 ? s : Math.min(s, nr(e.year(), r)), e._isUTC ? e._d.setUTCMonth(r, s) : e._d.setMonth(r, s), e;
}
function Gr(e) {
  return e != null ? (jr(this, e), d.updateOffset(this, !0), this) : Ge(this, "Month");
}
function xn() {
  return nr(this.year(), this.month());
}
function Pn(e) {
  return this._monthsParseExact ? (w(this, "_monthsRegex") || zr.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (w(this, "_monthsShortRegex") || (this._monthsShortRegex = Mn), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Nn(e) {
  return this._monthsParseExact ? (w(this, "_monthsRegex") || zr.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (w(this, "_monthsRegex") || (this._monthsRegex = Dn), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function zr() {
  function e(h, u) {
    return u.length - h.length;
  }
  var t = [], r = [], s = [], n, a, i, o;
  for (n = 0; n < 12; n++)
    a = K([2e3, n]), i = oe(this.monthsShort(a, "")), o = oe(this.months(a, "")), t.push(i), r.push(o), s.push(o), s.push(i);
  t.sort(e), r.sort(e), s.sort(e), this._monthsRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Wn(e, t, r, s, n, a, i) {
  var o;
  return e < 100 && e >= 0 ? (o = new Date(e + 400, t, r, s, n, a, i), isFinite(o.getFullYear()) && o.setFullYear(e)) : o = new Date(e, t, r, s, n, a, i), o;
}
function ze(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function _t(e, t, r) {
  var s = 7 + t - r, n = (7 + ze(e, 0, s).getUTCDay() - t) % 7;
  return -n + s - 1;
}
function Zr(e, t, r, s, n) {
  var a = (7 + r - s) % 7, i = _t(e, s, n), o = 1 + 7 * (t - 1) + a + i, h, u;
  return o <= 0 ? (h = e - 1, u = je(h) + o) : o > je(e) ? (h = e + 1, u = o - je(e)) : (h = e, u = o), {
    year: h,
    dayOfYear: u
  };
}
function Ze(e, t, r) {
  var s = _t(e.year(), t, r), n = Math.floor((e.dayOfYear() - s - 1) / 7) + 1, a, i;
  return n < 1 ? (i = e.year() - 1, a = n + le(i, t, r)) : n > le(e.year(), t, r) ? (a = n - le(e.year(), t, r), i = e.year() + 1) : (i = e.year(), a = n), {
    week: a,
    year: i
  };
}
function le(e, t, r) {
  var s = _t(e, t, r), n = _t(e + 1, t, r);
  return (je(e) - s + n) / 7;
}
m("w", ["ww", 2], "wo", "week");
m("W", ["WW", 2], "Wo", "isoWeek");
c("w", M, Ie);
c("ww", M, I);
c("W", M, Ie);
c("WW", M, I);
Qe(
  ["w", "ww", "W", "WW"],
  function(e, t, r, s) {
    t[s.substr(0, 1)] = _(e);
  }
);
function Rn(e) {
  return Ze(e, this._week.dow, this._week.doy).week;
}
var Fn = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Cn() {
  return this._week.dow;
}
function In() {
  return this._week.doy;
}
function En(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function An(e) {
  var t = Ze(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
m("d", 0, "do", "day");
m("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
m("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
m("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
m("e", 0, 0, "weekday");
m("E", 0, 0, "isoWeekday");
c("d", M);
c("e", M);
c("E", M);
c("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
c("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
c("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
Qe(["dd", "ddd", "dddd"], function(e, t, r, s) {
  var n = r._locale.weekdaysParse(e, s, r._strict);
  n != null ? t.d = n : y(r).invalidWeekday = e;
});
Qe(["d", "e", "E"], function(e, t, r, s) {
  t[s] = _(e);
});
function Ln(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Un(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function ar(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Hn = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), $r = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Vn = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), jn = Je, Gn = Je, zn = Je;
function Zn(e, t) {
  var r = Z(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? ar(r, this._week.dow) : e ? r[e.day()] : r;
}
function $n(e) {
  return e === !0 ? ar(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function qn(e) {
  return e === !0 ? ar(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Bn(e, t, r) {
  var s, n, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s)
      a = K([2e3, 1]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (n = O.call(this._weekdaysParse, i), n !== -1 ? n : null) : t === "ddd" ? (n = O.call(this._shortWeekdaysParse, i), n !== -1 ? n : null) : (n = O.call(this._minWeekdaysParse, i), n !== -1 ? n : null) : t === "dddd" ? (n = O.call(this._weekdaysParse, i), n !== -1 || (n = O.call(this._shortWeekdaysParse, i), n !== -1) ? n : (n = O.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : t === "ddd" ? (n = O.call(this._shortWeekdaysParse, i), n !== -1 || (n = O.call(this._weekdaysParse, i), n !== -1) ? n : (n = O.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : (n = O.call(this._minWeekdaysParse, i), n !== -1 || (n = O.call(this._weekdaysParse, i), n !== -1) ? n : (n = O.call(this._shortWeekdaysParse, i), n !== -1 ? n : null));
}
function Jn(e, t, r) {
  var s, n, a;
  if (this._weekdaysParseExact)
    return Bn.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++) {
    if (n = K([2e3, 1]).day(s), r && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp(
      "^" + this.weekdays(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[s] = new RegExp(
      "^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[s] = new RegExp(
      "^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[s] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[s] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[s].test(e))
      return s;
    if (r && t === "ddd" && this._shortWeekdaysParse[s].test(e))
      return s;
    if (r && t === "dd" && this._minWeekdaysParse[s].test(e))
      return s;
    if (!r && this._weekdaysParse[s].test(e))
      return s;
  }
}
function Qn(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = Ge(this, "Day");
  return e != null ? (e = Ln(e, this.localeData()), this.add(e - t, "d")) : t;
}
function Kn(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Xn(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Un(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function ea(e) {
  return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || ir.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (w(this, "_weekdaysRegex") || (this._weekdaysRegex = jn), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function ta(e) {
  return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || ir.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (w(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Gn), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function ra(e) {
  return this._weekdaysParseExact ? (w(this, "_weekdaysRegex") || ir.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (w(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = zn), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function ir() {
  function e(f, D) {
    return D.length - f.length;
  }
  var t = [], r = [], s = [], n = [], a, i, o, h, u;
  for (a = 0; a < 7; a++)
    i = K([2e3, 1]).day(a), o = oe(this.weekdaysMin(i, "")), h = oe(this.weekdaysShort(i, "")), u = oe(this.weekdays(i, "")), t.push(o), r.push(h), s.push(u), n.push(o), n.push(h), n.push(u);
  t.sort(e), r.sort(e), s.sort(e), n.sort(e), this._weekdaysRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + s.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function or() {
  return this.hours() % 12 || 12;
}
function sa() {
  return this.hours() || 24;
}
m("H", ["HH", 2], 0, "hour");
m("h", ["hh", 2], 0, or);
m("k", ["kk", 2], 0, sa);
m("hmm", 0, 0, function() {
  return "" + or.apply(this) + Q(this.minutes(), 2);
});
m("hmmss", 0, 0, function() {
  return "" + or.apply(this) + Q(this.minutes(), 2) + Q(this.seconds(), 2);
});
m("Hmm", 0, 0, function() {
  return "" + this.hours() + Q(this.minutes(), 2);
});
m("Hmmss", 0, 0, function() {
  return "" + this.hours() + Q(this.minutes(), 2) + Q(this.seconds(), 2);
});
function qr(e, t) {
  m(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
qr("a", !0);
qr("A", !1);
function Br(e, t) {
  return t._meridiemParse;
}
c("a", Br);
c("A", Br);
c("H", M, sr);
c("h", M, Ie);
c("k", M, Ie);
c("HH", M, I);
c("hh", M, I);
c("kk", M, I);
c("hmm", Er);
c("hmmss", Ar);
c("Hmm", Er);
c("Hmmss", Ar);
k(["H", "HH"], b);
k(["k", "kk"], function(e, t, r) {
  var s = _(e);
  t[b] = s === 24 ? 0 : s;
});
k(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
k(["h", "hh"], function(e, t, r) {
  t[b] = _(e), y(r).bigHour = !0;
});
k("hmm", function(e, t, r) {
  var s = e.length - 2;
  t[b] = _(e.substr(0, s)), t[z] = _(e.substr(s)), y(r).bigHour = !0;
});
k("hmmss", function(e, t, r) {
  var s = e.length - 4, n = e.length - 2;
  t[b] = _(e.substr(0, s)), t[z] = _(e.substr(s, 2)), t[ie] = _(e.substr(n)), y(r).bigHour = !0;
});
k("Hmm", function(e, t, r) {
  var s = e.length - 2;
  t[b] = _(e.substr(0, s)), t[z] = _(e.substr(s));
});
k("Hmmss", function(e, t, r) {
  var s = e.length - 4, n = e.length - 2;
  t[b] = _(e.substr(0, s)), t[z] = _(e.substr(s, 2)), t[ie] = _(e.substr(n));
});
function na(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var aa = /[ap]\.?m?\.?/i, ia = Ee("Hours", !0);
function oa(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var Jr = {
  calendar: qs,
  longDateFormat: Ks,
  invalidDate: en,
  ordinal: rn,
  dayOfMonthOrdinalParse: sn,
  relativeTime: an,
  months: Sn,
  monthsShort: Hr,
  week: Fn,
  weekdays: Hn,
  weekdaysMin: Vn,
  weekdaysShort: $r,
  meridiemParse: aa
}, Y = {}, Ue = {}, $e;
function la(e, t) {
  var r, s = Math.min(e.length, t.length);
  for (r = 0; r < s; r += 1)
    if (e[r] !== t[r])
      return r;
  return s;
}
function Or(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function ua(e) {
  for (var t = 0, r, s, n, a; t < e.length; ) {
    for (a = Or(e[t]).split("-"), r = a.length, s = Or(e[t + 1]), s = s ? s.split("-") : null; r > 0; ) {
      if (n = bt(a.slice(0, r).join("-")), n)
        return n;
      if (s && s.length >= r && la(a, s) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return $e;
}
function da(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function bt(e) {
  var t = null, r;
  if (Y[e] === void 0 && typeof module < "u" && module && module.exports && da(e))
    try {
      t = $e._abbr, r = require, r("./locale/" + e), ye(t);
    } catch {
      Y[e] = null;
    }
  return Y[e];
}
function ye(e, t) {
  var r;
  return e && (C(t) ? r = de(e) : r = lr(e, t), r ? $e = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), $e._abbr;
}
function lr(e, t) {
  if (t !== null) {
    var r, s = Jr;
    if (t.abbr = e, Y[e] != null)
      Rr(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), s = Y[e]._config;
    else if (t.parentLocale != null)
      if (Y[t.parentLocale] != null)
        s = Y[t.parentLocale]._config;
      else if (r = bt(t.parentLocale), r != null)
        s = r._config;
      else
        return Ue[t.parentLocale] || (Ue[t.parentLocale] = []), Ue[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return Y[e] = new Kt(Vt(s, t)), Ue[e] && Ue[e].forEach(function(n) {
      lr(n.name, n.config);
    }), ye(e), Y[e];
  } else
    return delete Y[e], null;
}
function fa(e, t) {
  if (t != null) {
    var r, s, n = Jr;
    Y[e] != null && Y[e].parentLocale != null ? Y[e].set(Vt(Y[e]._config, t)) : (s = bt(e), s != null && (n = s._config), t = Vt(n, t), s == null && (t.abbr = e), r = new Kt(t), r.parentLocale = Y[e], Y[e] = r), ye(e);
  } else
    Y[e] != null && (Y[e].parentLocale != null ? (Y[e] = Y[e].parentLocale, e === ye() && ye(e)) : Y[e] != null && delete Y[e]);
  return Y[e];
}
function de(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return $e;
  if (!Z(e)) {
    if (t = bt(e), t)
      return t;
    e = [e];
  }
  return ua(e);
}
function ca() {
  return jt(Y);
}
function ur(e) {
  var t, r = e._a;
  return r && y(e).overflow === -2 && (t = r[ae] < 0 || r[ae] > 11 ? ae : r[J] < 1 || r[J] > nr(r[W], r[ae]) ? J : r[b] < 0 || r[b] > 24 || r[b] === 24 && (r[z] !== 0 || r[ie] !== 0 || r[ke] !== 0) ? b : r[z] < 0 || r[z] > 59 ? z : r[ie] < 0 || r[ie] > 59 ? ie : r[ke] < 0 || r[ke] > 999 ? ke : -1, y(e)._overflowDayOfYear && (t < W || t > J) && (t = J), y(e)._overflowWeeks && t === -1 && (t = _n), y(e)._overflowWeekday && t === -1 && (t = gn), y(e).overflow = t), e;
}
var ha = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ma = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ya = /Z|[+-]\d\d(?::?\d\d)?/, dt = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], At = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], _a = /^\/?Date\((-?\d+)/i, ga = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, wa = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function Qr(e) {
  var t, r, s = e._i, n = ha.exec(s) || ma.exec(s), a, i, o, h, u = dt.length, f = At.length;
  if (n) {
    for (y(e).iso = !0, t = 0, r = u; t < r; t++)
      if (dt[t][1].exec(n[1])) {
        i = dt[t][0], a = dt[t][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (n[3]) {
      for (t = 0, r = f; t < r; t++)
        if (At[t][1].exec(n[3])) {
          o = (n[2] || " ") + At[t][0];
          break;
        }
      if (o == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && o != null) {
      e._isValid = !1;
      return;
    }
    if (n[4])
      if (ya.exec(n[4]))
        h = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (o || "") + (h || ""), fr(e);
  } else
    e._isValid = !1;
}
function pa(e, t, r, s, n, a) {
  var i = [
    va(e),
    Hr.indexOf(t),
    parseInt(r, 10),
    parseInt(s, 10),
    parseInt(n, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function va(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function ka(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Sa(e, t, r) {
  if (e) {
    var s = $r.indexOf(e), n = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (s !== n)
      return y(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function Ma(e, t, r) {
  if (e)
    return wa[e];
  if (t)
    return 0;
  var s = parseInt(r, 10), n = s % 100, a = (s - n) / 100;
  return a * 60 + n;
}
function Kr(e) {
  var t = ga.exec(ka(e._i)), r;
  if (t) {
    if (r = pa(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Sa(t[1], r, e))
      return;
    e._a = r, e._tzm = Ma(t[8], t[9], t[10]), e._d = ze.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), y(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Da(e) {
  var t = _a.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (Qr(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Kr(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : d.createFromInputFallback(e);
}
d.createFromInputFallback = H(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function xe(e, t, r) {
  return e ?? t ?? r;
}
function Ya(e) {
  var t = new Date(d.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function dr(e) {
  var t, r, s = [], n, a, i;
  if (!e._d) {
    for (n = Ya(e), e._w && e._a[J] == null && e._a[ae] == null && Oa(e), e._dayOfYear != null && (i = xe(e._a[W], n[W]), (e._dayOfYear > je(i) || e._dayOfYear === 0) && (y(e)._overflowDayOfYear = !0), r = ze(i, 0, e._dayOfYear), e._a[ae] = r.getUTCMonth(), e._a[J] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = s[t] = n[t];
    for (; t < 7; t++)
      e._a[t] = s[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[b] === 24 && e._a[z] === 0 && e._a[ie] === 0 && e._a[ke] === 0 && (e._nextDay = !0, e._a[b] = 0), e._d = (e._useUTC ? ze : Wn).apply(
      null,
      s
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[b] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (y(e).weekdayMismatch = !0);
  }
}
function Oa(e) {
  var t, r, s, n, a, i, o, h, u;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, i = 4, r = xe(
    t.GG,
    e._a[W],
    Ze(S(), 1, 4).year
  ), s = xe(t.W, 1), n = xe(t.E, 1), (n < 1 || n > 7) && (h = !0)) : (a = e._locale._week.dow, i = e._locale._week.doy, u = Ze(S(), a, i), r = xe(t.gg, e._a[W], u.year), s = xe(t.w, u.week), t.d != null ? (n = t.d, (n < 0 || n > 6) && (h = !0)) : t.e != null ? (n = t.e + a, (t.e < 0 || t.e > 6) && (h = !0)) : n = a), s < 1 || s > le(r, a, i) ? y(e)._overflowWeeks = !0 : h != null ? y(e)._overflowWeekday = !0 : (o = Zr(r, s, n, a, i), e._a[W] = o.year, e._dayOfYear = o.dayOfYear);
}
d.ISO_8601 = function() {
};
d.RFC_2822 = function() {
};
function fr(e) {
  if (e._f === d.ISO_8601) {
    Qr(e);
    return;
  }
  if (e._f === d.RFC_2822) {
    Kr(e);
    return;
  }
  e._a = [], y(e).empty = !0;
  var t = "" + e._i, r, s, n, a, i, o = t.length, h = 0, u, f;
  for (n = Fr(e._f, e._locale).match(Xt) || [], f = n.length, r = 0; r < f; r++)
    a = n[r], s = (t.match(hn(a, e)) || [])[0], s && (i = t.substr(0, t.indexOf(s)), i.length > 0 && y(e).unusedInput.push(i), t = t.slice(
      t.indexOf(s) + s.length
    ), h += s.length), We[a] ? (s ? y(e).empty = !1 : y(e).unusedTokens.push(a), yn(a, s, e)) : e._strict && !s && y(e).unusedTokens.push(a);
  y(e).charsLeftOver = o - h, t.length > 0 && y(e).unusedInput.push(t), e._a[b] <= 12 && y(e).bigHour === !0 && e._a[b] > 0 && (y(e).bigHour = void 0), y(e).parsedDateParts = e._a.slice(0), y(e).meridiem = e._meridiem, e._a[b] = ba(
    e._locale,
    e._a[b],
    e._meridiem
  ), u = y(e).era, u !== null && (e._a[W] = e._locale.erasConvertYear(u, e._a[W])), dr(e), ur(e);
}
function ba(e, t, r) {
  var s;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (s = e.isPM(r), s && t < 12 && (t += 12), !s && t === 12 && (t = 0)), t);
}
function Ta(e) {
  var t, r, s, n, a, i, o = !1, h = e._f.length;
  if (h === 0) {
    y(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (n = 0; n < h; n++)
    a = 0, i = !1, t = Qt({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[n], fr(t), Jt(t) && (i = !0), a += y(t).charsLeftOver, a += y(t).unusedTokens.length * 10, y(t).score = a, o ? a < s && (s = a, r = t) : (s == null || a < s || i) && (s = a, r = t, i && (o = !0));
  he(e, r || t);
}
function xa(e) {
  if (!e._d) {
    var t = er(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = Nr(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(s) {
        return s && parseInt(s, 10);
      }
    ), dr(e);
  }
}
function Pa(e) {
  var t = new Be(ur(Xr(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Xr(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || de(e._l), t === null || r === void 0 && t === "" ? vt({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), $(t) ? new Be(ur(t)) : (qe(t) ? e._d = t : Z(r) ? Ta(e) : r ? fr(e) : Na(e), Jt(e) || (e._d = null), e));
}
function Na(e) {
  var t = e._i;
  C(t) ? e._d = new Date(d.now()) : qe(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Da(e) : Z(t) ? (e._a = Nr(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), dr(e)) : Se(t) ? xa(e) : ue(t) ? e._d = new Date(t) : d.createFromInputFallback(e);
}
function es(e, t, r, s, n) {
  var a = {};
  return (t === !0 || t === !1) && (s = t, t = void 0), (r === !0 || r === !1) && (s = r, r = void 0), (Se(e) && Bt(e) || Z(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = n, a._l = r, a._i = e, a._f = t, a._strict = s, Pa(a);
}
function S(e, t, r, s) {
  return es(e, t, r, s, !1);
}
var Wa = H(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = S.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : vt();
  }
), Ra = H(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = S.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : vt();
  }
);
function ts(e, t) {
  var r, s;
  if (t.length === 1 && Z(t[0]) && (t = t[0]), !t.length)
    return S();
  for (r = t[0], s = 1; s < t.length; ++s)
    (!t[s].isValid() || t[s][e](r)) && (r = t[s]);
  return r;
}
function Fa() {
  var e = [].slice.call(arguments, 0);
  return ts("isBefore", e);
}
function Ca() {
  var e = [].slice.call(arguments, 0);
  return ts("isAfter", e);
}
var Ia = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, He = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function Ea(e) {
  var t, r = !1, s, n = He.length;
  for (t in e)
    if (w(e, t) && !(O.call(He, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (s = 0; s < n; ++s)
    if (e[He[s]]) {
      if (r)
        return !1;
      parseFloat(e[He[s]]) !== _(e[He[s]]) && (r = !0);
    }
  return !0;
}
function Aa() {
  return this._isValid;
}
function La() {
  return q(NaN);
}
function Tt(e) {
  var t = er(e), r = t.year || 0, s = t.quarter || 0, n = t.month || 0, a = t.week || t.isoWeek || 0, i = t.day || 0, o = t.hour || 0, h = t.minute || 0, u = t.second || 0, f = t.millisecond || 0;
  this._isValid = Ea(t), this._milliseconds = +f + u * 1e3 + // 1000
  h * 6e4 + // 1000 * 60
  o * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +n + s * 3 + r * 12, this._data = {}, this._locale = de(), this._bubble();
}
function ct(e) {
  return e instanceof Tt;
}
function zt(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Ua(e, t, r) {
  var s = Math.min(e.length, t.length), n = Math.abs(e.length - t.length), a = 0, i;
  for (i = 0; i < s; i++)
    _(e[i]) !== _(t[i]) && a++;
  return a + n;
}
function rs(e, t) {
  m(e, 0, 0, function() {
    var r = this.utcOffset(), s = "+";
    return r < 0 && (r = -r, s = "-"), s + Q(~~(r / 60), 2) + t + Q(~~r % 60, 2);
  });
}
rs("Z", ":");
rs("ZZ", "");
c("Z", Yt);
c("ZZ", Yt);
k(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = cr(Yt, e);
});
var Ha = /([\+\-]|\d\d)/gi;
function cr(e, t) {
  var r = (t || "").match(e), s, n, a;
  return r === null ? null : (s = r[r.length - 1] || [], n = (s + "").match(Ha) || ["-", 0, 0], a = +(n[1] * 60) + _(n[2]), a === 0 ? 0 : n[0] === "+" ? a : -a);
}
function hr(e, t) {
  var r, s;
  return t._isUTC ? (r = t.clone(), s = ($(e) || qe(e) ? e.valueOf() : S(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + s), d.updateOffset(r, !1), r) : S(e).local();
}
function Zt(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
d.updateOffset = function() {
};
function Va(e, t, r) {
  var s = this._offset || 0, n;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = cr(Yt, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (n = Zt(this)), this._offset = e, this._isUTC = !0, n != null && this.add(n, "m"), s !== e && (!t || this._changeInProgress ? as(
      this,
      q(e - s, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, d.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? s : Zt(this);
}
function ja(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Ga(e) {
  return this.utcOffset(0, e);
}
function za(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Zt(this), "m")), this;
}
function Za() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = cr(fn, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function $a(e) {
  return this.isValid() ? (e = e ? S(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function qa() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function Ba() {
  if (!C(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Qt(e, this), e = Xr(e), e._a ? (t = e._isUTC ? K(e._a) : S(e._a), this._isDSTShifted = this.isValid() && Ua(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Ja() {
  return this.isValid() ? !this._isUTC : !1;
}
function Qa() {
  return this.isValid() ? this._isUTC : !1;
}
function ss() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Ka = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Xa = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function q(e, t) {
  var r = e, s = null, n, a, i;
  return ct(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : ue(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (s = Ka.exec(e)) ? (n = s[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: _(s[J]) * n,
    h: _(s[b]) * n,
    m: _(s[z]) * n,
    s: _(s[ie]) * n,
    ms: _(zt(s[ke] * 1e3)) * n
    // the millisecond decimal point is included in the match
  }) : (s = Xa.exec(e)) ? (n = s[1] === "-" ? -1 : 1, r = {
    y: ve(s[2], n),
    M: ve(s[3], n),
    w: ve(s[4], n),
    d: ve(s[5], n),
    h: ve(s[6], n),
    m: ve(s[7], n),
    s: ve(s[8], n)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (i = ei(
    S(r.from),
    S(r.to)
  ), r = {}, r.ms = i.milliseconds, r.M = i.months), a = new Tt(r), ct(e) && w(e, "_locale") && (a._locale = e._locale), ct(e) && w(e, "_isValid") && (a._isValid = e._isValid), a;
}
q.fn = Tt.prototype;
q.invalid = La;
function ve(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function br(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function ei(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = hr(t, e), e.isBefore(t) ? r = br(e, t) : (r = br(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function ns(e, t) {
  return function(r, s) {
    var n, a;
    return s !== null && !isNaN(+s) && (Rr(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = s, s = a), n = q(r, s), as(this, n, e), this;
  };
}
function as(e, t, r, s) {
  var n = t._milliseconds, a = zt(t._days), i = zt(t._months);
  e.isValid() && (s = s ?? !0, i && jr(e, Ge(e, "Month") + i * r), a && Ur(e, "Date", Ge(e, "Date") + a * r), n && e._d.setTime(e._d.valueOf() + n * r), s && d.updateOffset(e, a || i));
}
var ti = ns(1, "add"), ri = ns(-1, "subtract");
function is(e) {
  return typeof e == "string" || e instanceof String;
}
function si(e) {
  return $(e) || qe(e) || is(e) || ue(e) || ai(e) || ni(e) || e === null || e === void 0;
}
function ni(e) {
  var t = Se(e) && !Bt(e), r = !1, s = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], n, a, i = s.length;
  for (n = 0; n < i; n += 1)
    a = s[n], r = r || w(e, a);
  return t && r;
}
function ai(e) {
  var t = Z(e), r = !1;
  return t && (r = e.filter(function(s) {
    return !ue(s) && is(e);
  }).length === 0), t && r;
}
function ii(e) {
  var t = Se(e) && !Bt(e), r = !1, s = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], n, a;
  for (n = 0; n < s.length; n += 1)
    a = s[n], r = r || w(e, a);
  return t && r;
}
function oi(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function li(e, t) {
  arguments.length === 1 && (arguments[0] ? si(arguments[0]) ? (e = arguments[0], t = void 0) : ii(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || S(), s = hr(r, this).startOf("day"), n = d.calendarFormat(this, s) || "sameElse", a = t && (X(t[n]) ? t[n].call(this, r) : t[n]);
  return this.format(
    a || this.localeData().calendar(n, this, S(r))
  );
}
function ui() {
  return new Be(this);
}
function di(e, t) {
  var r = $(e) ? e : S(e);
  return this.isValid() && r.isValid() ? (t = V(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function fi(e, t) {
  var r = $(e) ? e : S(e);
  return this.isValid() && r.isValid() ? (t = V(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function ci(e, t, r, s) {
  var n = $(e) ? e : S(e), a = $(t) ? t : S(t);
  return this.isValid() && n.isValid() && a.isValid() ? (s = s || "()", (s[0] === "(" ? this.isAfter(n, r) : !this.isBefore(n, r)) && (s[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function hi(e, t) {
  var r = $(e) ? e : S(e), s;
  return this.isValid() && r.isValid() ? (t = V(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (s = r.valueOf(), this.clone().startOf(t).valueOf() <= s && s <= this.clone().endOf(t).valueOf())) : !1;
}
function mi(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function yi(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function _i(e, t, r) {
  var s, n, a;
  if (!this.isValid())
    return NaN;
  if (s = hr(e, this), !s.isValid())
    return NaN;
  switch (n = (s.utcOffset() - this.utcOffset()) * 6e4, t = V(t), t) {
    case "year":
      a = ht(this, s) / 12;
      break;
    case "month":
      a = ht(this, s);
      break;
    case "quarter":
      a = ht(this, s) / 3;
      break;
    case "second":
      a = (this - s) / 1e3;
      break;
    // 1000
    case "minute":
      a = (this - s) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      a = (this - s) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      a = (this - s - n) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      a = (this - s - n) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      a = this - s;
  }
  return r ? a : U(a);
}
function ht(e, t) {
  if (e.date() < t.date())
    return -ht(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), s = e.clone().add(r, "months"), n, a;
  return t - s < 0 ? (n = e.clone().add(r - 1, "months"), a = (t - s) / (s - n)) : (n = e.clone().add(r + 1, "months"), a = (t - s) / (n - s)), -(r + a) || 0;
}
d.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
d.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function gi() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function wi(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? ft(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : X(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", ft(r, "Z")) : ft(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function pi() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, s, n, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', s = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + s + n + a);
}
function vi(e) {
  e || (e = this.isUtc() ? d.defaultFormatUtc : d.defaultFormat);
  var t = ft(this, e);
  return this.localeData().postformat(t);
}
function ki(e, t) {
  return this.isValid() && ($(e) && e.isValid() || S(e).isValid()) ? q({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Si(e) {
  return this.from(S(), e);
}
function Mi(e, t) {
  return this.isValid() && ($(e) && e.isValid() || S(e).isValid()) ? q({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Di(e) {
  return this.to(S(), e);
}
function os(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = de(e), t != null && (this._locale = t), this);
}
var ls = H(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function us() {
  return this._locale;
}
var gt = 1e3, Re = 60 * gt, wt = 60 * Re, ds = (365 * 400 + 97) * 24 * wt;
function Fe(e, t) {
  return (e % t + t) % t;
}
function fs(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - ds : new Date(e, t, r).valueOf();
}
function cs(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - ds : Date.UTC(e, t, r);
}
function Yi(e) {
  var t, r;
  if (e = V(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? cs : fs, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Fe(
        t + (this._isUTC ? 0 : this.utcOffset() * Re),
        wt
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Fe(t, Re);
      break;
    case "second":
      t = this._d.valueOf(), t -= Fe(t, gt);
      break;
  }
  return this._d.setTime(t), d.updateOffset(this, !0), this;
}
function Oi(e) {
  var t, r;
  if (e = V(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? cs : fs, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += wt - Fe(
        t + (this._isUTC ? 0 : this.utcOffset() * Re),
        wt
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Re - Fe(t, Re) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += gt - Fe(t, gt) - 1;
      break;
  }
  return this._d.setTime(t), d.updateOffset(this, !0), this;
}
function bi() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Ti() {
  return Math.floor(this.valueOf() / 1e3);
}
function xi() {
  return new Date(this.valueOf());
}
function Pi() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Ni() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Wi() {
  return this.isValid() ? this.toISOString() : null;
}
function Ri() {
  return Jt(this);
}
function Fi() {
  return he({}, y(this));
}
function Ci() {
  return y(this).overflow;
}
function Ii() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
m("N", 0, 0, "eraAbbr");
m("NN", 0, 0, "eraAbbr");
m("NNN", 0, 0, "eraAbbr");
m("NNNN", 0, 0, "eraName");
m("NNNNN", 0, 0, "eraNarrow");
m("y", ["y", 1], "yo", "eraYear");
m("y", ["yy", 2], 0, "eraYear");
m("y", ["yyy", 3], 0, "eraYear");
m("y", ["yyyy", 4], 0, "eraYear");
c("N", mr);
c("NN", mr);
c("NNN", mr);
c("NNNN", $i);
c("NNNNN", qi);
k(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, s) {
    var n = r._locale.erasParse(e, s, r._strict);
    n ? y(r).era = n : y(r).invalidEra = e;
  }
);
c("y", Ce);
c("yy", Ce);
c("yyy", Ce);
c("yyyy", Ce);
c("yo", Bi);
k(["y", "yy", "yyy", "yyyy"], W);
k(["yo"], function(e, t, r, s) {
  var n;
  r._locale._eraYearOrdinalRegex && (n = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[W] = r._locale.eraYearOrdinalParse(e, n) : t[W] = parseInt(e, 10);
});
function Ei(e, t) {
  var r, s, n, a = this._eras || de("en")._eras;
  for (r = 0, s = a.length; r < s; ++r)
    switch (typeof a[r].since === "string" && (n = d(a[r].since).startOf("day"), a[r].since = n.valueOf()), typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        n = d(a[r].until).startOf("day").valueOf(), a[r].until = n.valueOf();
        break;
    }
  return a;
}
function Ai(e, t, r) {
  var s, n, a = this.eras(), i, o, h;
  for (e = e.toUpperCase(), s = 0, n = a.length; s < n; ++s)
    if (i = a[s].name.toUpperCase(), o = a[s].abbr.toUpperCase(), h = a[s].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (o === e)
            return a[s];
          break;
        case "NNNN":
          if (i === e)
            return a[s];
          break;
        case "NNNNN":
          if (h === e)
            return a[s];
          break;
      }
    else if ([i, o, h].indexOf(e) >= 0)
      return a[s];
}
function Li(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? d(e.since).year() : d(e.since).year() + (t - e.offset) * r;
}
function Ui() {
  var e, t, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return s[e].name;
  return "";
}
function Hi() {
  var e, t, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return s[e].narrow;
  return "";
}
function Vi() {
  var e, t, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return s[e].abbr;
  return "";
}
function ji() {
  var e, t, r, s, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = n[e].since <= n[e].until ? 1 : -1, s = this.clone().startOf("day").valueOf(), n[e].since <= s && s <= n[e].until || n[e].until <= s && s <= n[e].since)
      return (this.year() - d(n[e].since).year()) * r + n[e].offset;
  return this.year();
}
function Gi(e) {
  return w(this, "_erasNameRegex") || yr.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function zi(e) {
  return w(this, "_erasAbbrRegex") || yr.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Zi(e) {
  return w(this, "_erasNarrowRegex") || yr.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function mr(e, t) {
  return t.erasAbbrRegex(e);
}
function $i(e, t) {
  return t.erasNameRegex(e);
}
function qi(e, t) {
  return t.erasNarrowRegex(e);
}
function Bi(e, t) {
  return t._eraYearOrdinalRegex || Ce;
}
function yr() {
  var e = [], t = [], r = [], s = [], n, a, i, o, h, u = this.eras();
  for (n = 0, a = u.length; n < a; ++n)
    i = oe(u[n].name), o = oe(u[n].abbr), h = oe(u[n].narrow), t.push(i), e.push(o), r.push(h), s.push(i), s.push(o), s.push(h);
  this._erasRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
m(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
m(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function xt(e, t) {
  m(0, [e, e.length], 0, t);
}
xt("gggg", "weekYear");
xt("ggggg", "weekYear");
xt("GGGG", "isoWeekYear");
xt("GGGGG", "isoWeekYear");
c("G", Dt);
c("g", Dt);
c("GG", M, I);
c("gg", M, I);
c("GGGG", rr, tr);
c("gggg", rr, tr);
c("GGGGG", Mt, kt);
c("ggggg", Mt, kt);
Qe(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, s) {
    t[s.substr(0, 2)] = _(e);
  }
);
Qe(["gg", "GG"], function(e, t, r, s) {
  t[s] = d.parseTwoDigitYear(e);
});
function Ji(e) {
  return hs.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Qi(e) {
  return hs.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Ki() {
  return le(this.year(), 1, 4);
}
function Xi() {
  return le(this.isoWeekYear(), 1, 4);
}
function eo() {
  var e = this.localeData()._week;
  return le(this.year(), e.dow, e.doy);
}
function to() {
  var e = this.localeData()._week;
  return le(this.weekYear(), e.dow, e.doy);
}
function hs(e, t, r, s, n) {
  var a;
  return e == null ? Ze(this, s, n).year : (a = le(e, s, n), t > a && (t = a), ro.call(this, e, t, r, s, n));
}
function ro(e, t, r, s, n) {
  var a = Zr(e, t, r, s, n), i = ze(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
m("Q", 0, "Qo", "quarter");
c("Q", Cr);
k("Q", function(e, t) {
  t[ae] = (_(e) - 1) * 3;
});
function so(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
m("D", ["DD", 2], "Do", "date");
c("D", M, Ie);
c("DD", M, I);
c("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
k(["D", "DD"], J);
k("Do", function(e, t) {
  t[J] = _(e.match(M)[0]);
});
var ms = Ee("Date", !0);
m("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
c("DDD", St);
c("DDDD", Ir);
k(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = _(e);
});
function no(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
m("m", ["mm", 2], 0, "minute");
c("m", M, sr);
c("mm", M, I);
k(["m", "mm"], z);
var ao = Ee("Minutes", !1);
m("s", ["ss", 2], 0, "second");
c("s", M, sr);
c("ss", M, I);
k(["s", "ss"], ie);
var io = Ee("Seconds", !1);
m("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
m(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
m(0, ["SSS", 3], 0, "millisecond");
m(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
m(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
m(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
m(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
m(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
m(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
c("S", St, Cr);
c("SS", St, I);
c("SSS", St, Ir);
var me, ys;
for (me = "SSSS"; me.length <= 9; me += "S")
  c(me, Ce);
function oo(e, t) {
  t[ke] = _(("0." + e) * 1e3);
}
for (me = "S"; me.length <= 9; me += "S")
  k(me, oo);
ys = Ee("Milliseconds", !1);
m("z", 0, 0, "zoneAbbr");
m("zz", 0, 0, "zoneName");
function lo() {
  return this._isUTC ? "UTC" : "";
}
function uo() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var l = Be.prototype;
l.add = ti;
l.calendar = li;
l.clone = ui;
l.diff = _i;
l.endOf = Oi;
l.format = vi;
l.from = ki;
l.fromNow = Si;
l.to = Mi;
l.toNow = Di;
l.get = pn;
l.invalidAt = Ci;
l.isAfter = di;
l.isBefore = fi;
l.isBetween = ci;
l.isSame = hi;
l.isSameOrAfter = mi;
l.isSameOrBefore = yi;
l.isValid = Ri;
l.lang = ls;
l.locale = os;
l.localeData = us;
l.max = Ra;
l.min = Wa;
l.parsingFlags = Fi;
l.set = vn;
l.startOf = Yi;
l.subtract = ri;
l.toArray = Pi;
l.toObject = Ni;
l.toDate = xi;
l.toISOString = wi;
l.inspect = pi;
typeof Symbol < "u" && Symbol.for != null && (l[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
l.toJSON = Wi;
l.toString = gi;
l.unix = Ti;
l.valueOf = bi;
l.creationData = Ii;
l.eraName = Ui;
l.eraNarrow = Hi;
l.eraAbbr = Vi;
l.eraYear = ji;
l.year = Lr;
l.isLeapYear = wn;
l.weekYear = Ji;
l.isoWeekYear = Qi;
l.quarter = l.quarters = so;
l.month = Gr;
l.daysInMonth = xn;
l.week = l.weeks = En;
l.isoWeek = l.isoWeeks = An;
l.weeksInYear = eo;
l.weeksInWeekYear = to;
l.isoWeeksInYear = Ki;
l.isoWeeksInISOWeekYear = Xi;
l.date = ms;
l.day = l.days = Qn;
l.weekday = Kn;
l.isoWeekday = Xn;
l.dayOfYear = no;
l.hour = l.hours = ia;
l.minute = l.minutes = ao;
l.second = l.seconds = io;
l.millisecond = l.milliseconds = ys;
l.utcOffset = Va;
l.utc = Ga;
l.local = za;
l.parseZone = Za;
l.hasAlignedHourOffset = $a;
l.isDST = qa;
l.isLocal = Ja;
l.isUtcOffset = Qa;
l.isUtc = ss;
l.isUTC = ss;
l.zoneAbbr = lo;
l.zoneName = uo;
l.dates = H(
  "dates accessor is deprecated. Use date instead.",
  ms
);
l.months = H(
  "months accessor is deprecated. Use month instead",
  Gr
);
l.years = H(
  "years accessor is deprecated. Use year instead",
  Lr
);
l.zone = H(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  ja
);
l.isDSTShifted = H(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  Ba
);
function fo(e) {
  return S(e * 1e3);
}
function co() {
  return S.apply(null, arguments).parseZone();
}
function _s(e) {
  return e;
}
var p = Kt.prototype;
p.calendar = Bs;
p.longDateFormat = Xs;
p.invalidDate = tn;
p.ordinal = nn;
p.preparse = _s;
p.postformat = _s;
p.relativeTime = on;
p.pastFuture = ln;
p.set = $s;
p.eras = Ei;
p.erasParse = Ai;
p.erasConvertYear = Li;
p.erasAbbrRegex = zi;
p.erasNameRegex = Gi;
p.erasNarrowRegex = Zi;
p.months = Yn;
p.monthsShort = On;
p.monthsParse = Tn;
p.monthsRegex = Nn;
p.monthsShortRegex = Pn;
p.week = Rn;
p.firstDayOfYear = In;
p.firstDayOfWeek = Cn;
p.weekdays = Zn;
p.weekdaysMin = qn;
p.weekdaysShort = $n;
p.weekdaysParse = Jn;
p.weekdaysRegex = ea;
p.weekdaysShortRegex = ta;
p.weekdaysMinRegex = ra;
p.isPM = na;
p.meridiem = oa;
function pt(e, t, r, s) {
  var n = de(), a = K().set(s, t);
  return n[r](a, e);
}
function gs(e, t, r) {
  if (ue(e) && (t = e, e = void 0), e = e || "", t != null)
    return pt(e, t, r, "month");
  var s, n = [];
  for (s = 0; s < 12; s++)
    n[s] = pt(e, s, r, "month");
  return n;
}
function _r(e, t, r, s) {
  typeof e == "boolean" ? (ue(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, ue(t) && (r = t, t = void 0), t = t || "");
  var n = de(), a = e ? n._week.dow : 0, i, o = [];
  if (r != null)
    return pt(t, (r + a) % 7, s, "day");
  for (i = 0; i < 7; i++)
    o[i] = pt(t, (i + a) % 7, s, "day");
  return o;
}
function ho(e, t) {
  return gs(e, t, "months");
}
function mo(e, t) {
  return gs(e, t, "monthsShort");
}
function yo(e, t, r) {
  return _r(e, t, r, "weekdays");
}
function _o(e, t, r) {
  return _r(e, t, r, "weekdaysShort");
}
function go(e, t, r) {
  return _r(e, t, r, "weekdaysMin");
}
ye("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = _(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
d.lang = H(
  "moment.lang is deprecated. Use moment.locale instead.",
  ye
);
d.langData = H(
  "moment.langData is deprecated. Use moment.localeData instead.",
  de
);
var se = Math.abs;
function wo() {
  var e = this._data;
  return this._milliseconds = se(this._milliseconds), this._days = se(this._days), this._months = se(this._months), e.milliseconds = se(e.milliseconds), e.seconds = se(e.seconds), e.minutes = se(e.minutes), e.hours = se(e.hours), e.months = se(e.months), e.years = se(e.years), this;
}
function ws(e, t, r, s) {
  var n = q(t, r);
  return e._milliseconds += s * n._milliseconds, e._days += s * n._days, e._months += s * n._months, e._bubble();
}
function po(e, t) {
  return ws(this, e, t, 1);
}
function vo(e, t) {
  return ws(this, e, t, -1);
}
function Tr(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function ko() {
  var e = this._milliseconds, t = this._days, r = this._months, s = this._data, n, a, i, o, h;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Tr($t(r) + t) * 864e5, t = 0, r = 0), s.milliseconds = e % 1e3, n = U(e / 1e3), s.seconds = n % 60, a = U(n / 60), s.minutes = a % 60, i = U(a / 60), s.hours = i % 24, t += U(i / 24), h = U(ps(t)), r += h, t -= Tr($t(h)), o = U(r / 12), r %= 12, s.days = t, s.months = r, s.years = o, this;
}
function ps(e) {
  return e * 4800 / 146097;
}
function $t(e) {
  return e * 146097 / 4800;
}
function So(e) {
  if (!this.isValid())
    return NaN;
  var t, r, s = this._milliseconds;
  if (e = V(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + s / 864e5, r = this._months + ps(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round($t(this._months)), e) {
      case "week":
        return t / 7 + s / 6048e5;
      case "day":
        return t + s / 864e5;
      case "hour":
        return t * 24 + s / 36e5;
      case "minute":
        return t * 1440 + s / 6e4;
      case "second":
        return t * 86400 + s / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + s;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function fe(e) {
  return function() {
    return this.as(e);
  };
}
var vs = fe("ms"), Mo = fe("s"), Do = fe("m"), Yo = fe("h"), Oo = fe("d"), bo = fe("w"), To = fe("M"), xo = fe("Q"), Po = fe("y"), No = vs;
function Wo() {
  return q(this);
}
function Ro(e) {
  return e = V(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Me(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Fo = Me("milliseconds"), Co = Me("seconds"), Io = Me("minutes"), Eo = Me("hours"), Ao = Me("days"), Lo = Me("months"), Uo = Me("years");
function Ho() {
  return U(this.days() / 7);
}
var ne = Math.round, Pe = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Vo(e, t, r, s, n) {
  return n.relativeTime(t || 1, !!r, e, s);
}
function jo(e, t, r, s) {
  var n = q(e).abs(), a = ne(n.as("s")), i = ne(n.as("m")), o = ne(n.as("h")), h = ne(n.as("d")), u = ne(n.as("M")), f = ne(n.as("w")), D = ne(n.as("y")), v = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || i <= 1 && ["m"] || i < r.m && ["mm", i] || o <= 1 && ["h"] || o < r.h && ["hh", o] || h <= 1 && ["d"] || h < r.d && ["dd", h];
  return r.w != null && (v = v || f <= 1 && ["w"] || f < r.w && ["ww", f]), v = v || u <= 1 && ["M"] || u < r.M && ["MM", u] || D <= 1 && ["y"] || ["yy", D], v[2] = t, v[3] = +e > 0, v[4] = s, Vo.apply(null, v);
}
function Go(e) {
  return e === void 0 ? ne : typeof e == "function" ? (ne = e, !0) : !1;
}
function zo(e, t) {
  return Pe[e] === void 0 ? !1 : t === void 0 ? Pe[e] : (Pe[e] = t, e === "s" && (Pe.ss = t - 1), !0);
}
function Zo(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, s = Pe, n, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (s = Object.assign({}, Pe, t), t.s != null && t.ss == null && (s.ss = t.s - 1)), n = this.localeData(), a = jo(this, !r, s, n), r && (a = n.pastFuture(+this, a)), n.postformat(a);
}
var Lt = Math.abs;
function Te(e) {
  return (e > 0) - (e < 0) || +e;
}
function Pt() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Lt(this._milliseconds) / 1e3, t = Lt(this._days), r = Lt(this._months), s, n, a, i, o = this.asSeconds(), h, u, f, D;
  return o ? (s = U(e / 60), n = U(s / 60), e %= 60, s %= 60, a = U(r / 12), r %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", h = o < 0 ? "-" : "", u = Te(this._months) !== Te(o) ? "-" : "", f = Te(this._days) !== Te(o) ? "-" : "", D = Te(this._milliseconds) !== Te(o) ? "-" : "", h + "P" + (a ? u + a + "Y" : "") + (r ? u + r + "M" : "") + (t ? f + t + "D" : "") + (n || s || e ? "T" : "") + (n ? D + n + "H" : "") + (s ? D + s + "M" : "") + (e ? D + i + "S" : "")) : "P0D";
}
var g = Tt.prototype;
g.isValid = Aa;
g.abs = wo;
g.add = po;
g.subtract = vo;
g.as = So;
g.asMilliseconds = vs;
g.asSeconds = Mo;
g.asMinutes = Do;
g.asHours = Yo;
g.asDays = Oo;
g.asWeeks = bo;
g.asMonths = To;
g.asQuarters = xo;
g.asYears = Po;
g.valueOf = No;
g._bubble = ko;
g.clone = Wo;
g.get = Ro;
g.milliseconds = Fo;
g.seconds = Co;
g.minutes = Io;
g.hours = Eo;
g.days = Ao;
g.weeks = Ho;
g.months = Lo;
g.years = Uo;
g.humanize = Zo;
g.toISOString = Pt;
g.toString = Pt;
g.toJSON = Pt;
g.locale = os;
g.localeData = us;
g.toIsoString = H(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Pt
);
g.lang = ls;
m("X", 0, 0, "unix");
m("x", 0, 0, "valueOf");
c("x", Dt);
c("X", cn);
k("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
k("x", function(e, t, r) {
  r._d = new Date(_(e));
});
d.version = "2.30.1";
zs(S);
d.fn = l;
d.min = Fa;
d.max = Ca;
d.now = Ia;
d.utc = K;
d.unix = fo;
d.months = ho;
d.isDate = qe;
d.locale = ye;
d.invalid = vt;
d.duration = q;
d.isMoment = $;
d.weekdays = yo;
d.parseZone = co;
d.localeData = de;
d.isDuration = ct;
d.monthsShort = mo;
d.weekdaysMin = go;
d.defineLocale = lr;
d.updateLocale = fa;
d.locales = ca;
d.weekdaysShort = _o;
d.normalizeUnits = V;
d.relativeTimeRounding = Go;
d.relativeTimeThreshold = zo;
d.calendarFormat = oi;
d.prototype = l;
d.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const $o = Ys(void 0), nl = (e) => {
  const t = Ds(50), {
    children: r,
    state: s,
    initialMessages: n,
    adapter: a,
    events: i,
    storageKey: o,
    onFeedback: h
  } = e;
  let u;
  t[0] !== n ? (u = n ?? [], t[0] = n, t[1] = u) : u = t[1];
  const [f, D] = re.useState(u), [v, E] = re.useState(!1), [R, _e] = re.useState(), [De, Ke] = re.useState(s.maximize ?? !0), [Ye, ge] = re.useState(""), Oe = re.useRef(null), x = Ns(), A = Ws();
  let we;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (we = (T) => {
    E(!0);
    const G = {
      id: `message-${Ut(14)}`,
      timestamp: d().unix(),
      message: T,
      role: "user",
      type: "text"
    };
    D((L) => [...L, G]);
  }, t[2] = we) : we = t[2];
  const ee = we;
  let pe;
  t[3] !== f || t[4] !== o ? (pe = () => {
    o && f.length > 0 && sessionStorage.setItem(o, JSON.stringify(f)), Oe.current && Oe.current.focus();
  }, t[3] = f, t[4] = o, t[5] = pe) : pe = t[5];
  let j;
  t[6] !== f.length || t[7] !== o ? (j = [f.length, o], t[6] = f.length, t[7] = o, t[8] = j) : j = t[8], re.useEffect(pe, j);
  let P;
  t[9] !== f || t[10] !== h || t[11] !== o ? (P = (T) => {
    const F = f.find((N) => N.id === T);
    if (!F)
      return;
    const G = F.feedback === 1 ? 0 : 1, L = f.map((N) => N.id === T ? {
      ...N,
      feedback: G
    } : N);
    D(L), h?.(T, F.message.toString(), G), o && L.length > 0 && sessionStorage.setItem(o, JSON.stringify(L));
  }, t[9] = f, t[10] = h, t[11] = o, t[12] = P) : P = t[12];
  const te = P;
  let Xe;
  t[13] !== f || t[14] !== h || t[15] !== o ? (Xe = (T) => {
    const F = f.find((N) => N.id === T);
    if (!F)
      return;
    const G = F.feedback === -1 ? 0 : -1, L = f.map((N) => N.id === T ? {
      ...N,
      feedback: G
    } : N);
    D(L), h?.(T, F.message.toString(), G), o && L.length > 0 && sessionStorage.setItem(o, JSON.stringify(L));
  }, t[13] = f, t[14] = h, t[15] = o, t[16] = Xe) : Xe = t[16];
  const Nt = Xe;
  let et;
  t[17] !== A ? (et = (T, F, G, L) => {
    const N = G === void 0 ? "assistant" : G;
    if (!F)
      return;
    const Ae = {
      id: T,
      timestamp: d().unix(),
      message: F,
      role: N,
      agent: L,
      type: "text"
    };
    return D((Le) => [...Le, Ae]), A.speak(F), E(!1), Ae;
  }, t[17] = A, t[18] = et) : et = t[18];
  const ce = et;
  let tt;
  t[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (tt = (T) => {
    Ke(T);
  }, t[19] = tt) : tt = t[19];
  const ks = tt;
  let rt;
  t[20] !== s ? (rt = () => {
    alert("Close"), s.onClose?.();
  }, t[20] = s, t[21] = rt) : rt = t[21];
  const Wt = rt;
  let st, nt;
  t[22] !== x.transcript || t[23] !== s.sendOnSpeech ? (st = () => {
    x.transcript && (s.sendOnSpeech ? ee(x.transcript) : ge(x.transcript));
  }, nt = [x.transcript, s.sendOnSpeech, ee], t[22] = x.transcript, t[23] = s.sendOnSpeech, t[24] = st, t[25] = nt) : (st = t[24], nt = t[25]), re.useEffect(st, nt);
  let at;
  t[26] !== a || t[27] !== f || t[28] !== i || t[29] !== v || t[30] !== ce ? (at = () => {
    const T = f[f.length - 1], F = T?.role === "user";
    v && F && async function() {
      const N = document.querySelector(".chatbot-body"), Ae = document.querySelector("#streaming > .message-wrapper > .message"), Le = `message-${Ut(14)}`;
      let Rt = "";
      const Ss = {
        next: (B, gr) => {
          if (gr && _e(gr), Rt = Rt + B, Ae) {
            const Ms = /* @__PURE__ */ wr(bs, { className: "message assistant", remarkPlugins: [Ts], rehypePlugins: [xs], children: Rt });
            Ae.innerHTML = Ps(Ms), N?.scrollTo(0, N.scrollHeight);
          }
        },
        complete: () => {
          E(!1), _e(void 0);
        },
        error: (B) => {
          console.error(B), ce(Le, B, "system");
        },
        system: (B) => {
          console.log("System: ", B), ce(Le, B, "system");
        },
        history: f
      }, lt = await a(T.message, Ss, {
        history: f
      });
      if (i?.onMessageSent?.(T.message), lt) {
        const B = ce(lt.messageId ?? Le, lt.message, "assistant", lt.sender);
        B && i?.onMessageReceived?.(B);
      }
    }();
  }, t[26] = a, t[27] = f, t[28] = i, t[29] = v, t[30] = ce, t[31] = at) : at = t[31];
  let it;
  t[32] !== i || t[33] !== v ? (it = [i, v], t[32] = i, t[33] = v, t[34] = it) : it = t[34], re.useEffect(at, it);
  let be;
  t[35] !== R || t[36] !== f || t[37] !== Nt || t[38] !== v || t[39] !== te || t[40] !== De || t[41] !== Wt || t[42] !== Ye || t[43] !== ce || t[44] !== x || t[45] !== A ? (be = {
    conversations: f,
    send: ee,
    receive: ce,
    isProcessing: v,
    agent: R,
    like: te,
    dislike: Nt,
    prompt: Ye,
    setPrompt: ge,
    maximize: De,
    onSizeChange: ks,
    onClose: Wt,
    inputRef: Oe,
    speech: x,
    transcription: A
  }, t[35] = R, t[36] = f, t[37] = Nt, t[38] = v, t[39] = te, t[40] = De, t[41] = Wt, t[42] = Ye, t[43] = ce, t[44] = x, t[45] = A, t[46] = be) : be = t[46];
  let ot;
  return t[47] !== r || t[48] !== be ? (ot = /* @__PURE__ */ wr($o.Provider, { value: be, children: r }), t[47] = r, t[48] = be, t[49] = ot) : ot = t[49], ot;
};
export {
  $o as C,
  nl as a,
  d as h
};
